(function() {
  'use strict';
  
  // Only run on product pages
  if (!document.body.classList.contains('template-product') && 
      !window.location.pathname.includes('/products/')) {
    return;
  }

  // List of selectors to remove
  const fittingRoomSelectors = [
    '[class*="fitting-room"]',
    '[data-fitting-room]',
    '[id*="fitting-room"]',
    '[id*="fitting_room"]',
    '[class*="fitting_room"]',
    '[data-fitting_room]',
    '.fitting-room',
    '.fitting_room',
    'div[id*="fitting"]',
    'div[class*="fitting"]',
    'iframe[src*="fitting"]',
    'iframe[src*="fittingroom"]',
    '[class*="photo-upload"]',
    '[class*="upload-photo"]',
    '[id*="photo-upload"]',
    '[id*="upload-photo"]',
    '[class*="virtual-try"]',
    '[class*="try-on"]',
    '[data-app*="fitting"]',
    '[data-app*="photo"]',
    '[data-app*="virtual"]',
    '.upload-section',
    '.photo-tips',
    '[class*="tips-section"]'
  ];

  // Text patterns to look for and remove elements containing them
  const textPatterns = [
    'UPLOAD YOUR PHOTO',
    'TIPS FOR BEST RESULTS',
    'PICK A CLEAR & HIGH QUALITY PHOTO',
    'SHOW YOUR FULL OR HALF BODY',
    'AVOID PHOTOS TAKEN FROM FAR AWAY',
    'NO ACCESSORIES LIKE HATS OR BAGS',
    'AVOID BULKY OR LOOSE OUTFITS',
    'ENSURE YOUR FACE IS FULLY VISIBLE'
  ];

  // Function to remove fitting room elements
  function removeFittingRoomElements() {
    // Remove by selectors
    fittingRoomSelectors.forEach(selector => {
      try {
        const elements = document.querySelectorAll(selector);
        elements.forEach(element => {
          if (element && element.parentNode) {
            element.remove();
          }
        });
      } catch (e) {
        // Ignore selector errors
      }
    });

    // Remove by text content
    textPatterns.forEach(pattern => {
      const walker = document.createTreeWalker(
        document.body,
        NodeFilter.SHOW_TEXT,
        null,
        false
      );

      const textNodes = [];
      let node;
      while (node = walker.nextNode()) {
        if (node.textContent.includes(pattern)) {
          textNodes.push(node);
        }
      }

      textNodes.forEach(textNode => {
        let element = textNode.parentElement;
        while (element && element !== document.body) {
          if (element.textContent.includes(pattern)) {
            element.remove();
            break;
          }
          element = element.parentElement;
        }
      });
    });

    // Remove elements with green background that might be the upload section
    const allElements = document.querySelectorAll('*');
    allElements.forEach(element => {
      const style = window.getComputedStyle(element);
      if (style.backgroundColor.includes('green') || 
          style.background.includes('green')) {
        const text = element.textContent || '';
        if (text.includes('UPLOAD') || text.includes('PHOTO') || text.includes('TIPS')) {
          element.remove();
        }
      }
    });
  }

  // Run immediately
  removeFittingRoomElements();

  // Run after DOM is loaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', removeFittingRoomElements);
  }

  // Run after quick view modals are opened/closed
  document.addEventListener('click', function(e) {
    // Check if it's a quick view button or modal close
    if (e.target.matches('[data-quick-view], .quick-view, .modal-close, .overlay') ||
        e.target.closest('[data-quick-view], .quick-view, .modal-close, .overlay')) {
      setTimeout(removeFittingRoomElements, 500);
    }
  });

  // Run when modals are opened/closed
  const observer = new MutationObserver(function(mutations) {
    let shouldCheck = false;
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) { // Element node
            const text = node.textContent || '';
            if (text.includes('UPLOAD') || text.includes('PHOTO') || text.includes('FITTING')) {
              shouldCheck = true;
            }
          }
        });
      }
    });
    
    if (shouldCheck) {
      setTimeout(removeFittingRoomElements, 100);
    }
  });

  // Start observing
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Expose function globally for manual cleanup
  window.removeFittingRoomElements = removeFittingRoomElements;

})();